let state = {
  stateFullScreen: false,
  activeItem: null,
  mode: null,
  stateSidebar: false,
};

const getters = {
  GET_STATE_FULL_SCREEN: state => state.stateFullScreen,
  GET_ACTIVE_ITEM: state => state.activeItem,
  GET_MODE: state => state.mode,
  GET_STATE_SIDEBAR: state => state.stateSidebar
};
const mutations = {
  SET_STATE_FULL_SCREEN(state, data) {
    state.stateFullScreen = data;
  },
  SET_ACTIVE_ITEM(state, data) {
    state.activeItem = data;
  },
  SET_MODE(state, data) {
    state.mode = data;
  },
  SET_STATE_SIDEBAR(state, data) {
    state.stateSidebar = data;
  }
};

const actions = {
  setStateFullScreen({ commit }, data) {
    commit("SET_STATE_FULL_SCREEN", data);
  },
  setActiveItem({ commit }, data) {
    commit("SET_ACTIVE_ITEM", data);
  },
  setModeView({ commit }, data) {
    commit("SET_MODE", data);
  },
  setStateSidebar({ commit }, data) {
    commit("SET_STATE_SIDEBAR", data);
  },
  reset({ commit }) {
    commit("SET_STATE_FULL_SCREEN", false);
    commit("SET_ACTIVE_ITEM", null);
    commit("SET_MODE", null);
    commit("SET_STATE_SIDEBAR", false);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
